// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"338":"09d0a2df","453":"5f51746b","463":"bdebc766"}[chunkId] + ".chunk.js";
};